// Function to check if any sub-option is true
function checkIfAnyOptionTrue(subObject) {
  // Ensure subObject is valid before checking values
  return (
    subObject &&
    typeof subObject === "object" &&
    Object.values(subObject).includes(true)
  );
}

// Retrieve the permissions from localStorage
// const permissions = JSON.parse(localStorage.getItem('permission')) || {};

// Function to check permissions dynamically
function checkPermission(permissions, permissionKey, subKey = null) {
  const permission = permissions?.[permissionKey];

  // If a subKey is provided, check for that key inside the permission object
  if (permission && subKey) {
    return permission[subKey] === true;
  }

  // If no subKey is provided, check if any option inside the permission object is true
  if (permission) {
    return checkIfAnyOptionTrue(permission);
  }

  return false;
}

// Function to check permission by roles and keys
export function checkPermissionByKey(user, permissionKey, subKey = null) {
  // const role = JSON.parse(localStorage.getItem('role')) || "";

  // Validate the role and permission key
  const role = user?.user?.role;
  if (role === "teamMember") {
    let permissions = user.user.permission;
    // Check if the permissionKey exists in permissions
    if (
      permissions &&
      typeof permissions === "object" &&
      permissions.hasOwnProperty(permissionKey)
    ) {
      return checkPermission(permissions, permissionKey, subKey);
    }
    return false; // Permission key doesn't exist
  }

  // Default behavior for roles other than "teamMember"
  return true;
}
